import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import type { ContractStatus } from '@shared/types';

interface ContractFiltersProps {
  statusFilter: ContractStatus | 'all';
  onStatusFilterChange: (status: ContractStatus | 'all') => void;
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  statusCounts: Record<ContractStatus | 'all', number>;
}

const statusConfig: Record<ContractStatus | 'all', { label: string; color: string }> = {
  all: { label: 'All', color: 'bg-gray-100 text-gray-700' },
  draft: { label: 'Draft', color: 'bg-yellow-100 text-yellow-700' },
  review: { label: 'Review', color: 'bg-blue-100 text-blue-700' },
  signature: { label: 'Signature', color: 'bg-purple-100 text-purple-700' },
  executed: { label: 'Executed', color: 'bg-green-100 text-green-700' },
  archived: { label: 'Archived', color: 'bg-gray-100 text-gray-700' },
};

export function ContractFilters({
  statusFilter,
  onStatusFilterChange,
  searchQuery,
  onSearchQueryChange,
  statusCounts,
}: ContractFiltersProps) {
  return (
    <div className="space-y-4">
      <div className="relative">
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search contracts by client name or summary..."
          value={searchQuery}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>

      <div className="flex gap-2 overflow-x-auto pb-2">
        {(Object.keys(statusConfig) as (ContractStatus | 'all')[]).map((status) => {
          const { label, color } = statusConfig[status];
          const count = statusCounts[status];
          const isActive = statusFilter === status;

          return (
            <button
              key={status}
              onClick={() => onStatusFilterChange(status)}
              className={`flex-shrink-0 px-4 py-2 rounded-lg font-medium transition-all ${
                isActive
                  ? 'bg-primary-600 text-white shadow-md'
                  : `${color} hover:shadow-sm`
              }`}
            >
              {label}
              <span className="ml-2 opacity-75">({count})</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

